export default function scrollTo(name: string): void {
  const divToScroll = document.getElementById(name);

  if (divToScroll) {
    window.scrollTo({
      top: divToScroll.offsetTop - 80,
      left: 0,
      behavior: 'smooth',
    });
  }
}
